export const Purpose_of_Enquiry_Options = [
  {
    name: 'Purpose of Enquiry' ,
    value: 'Purpose of Enquiry',
  },
  {
    name: 'General Enquiry',
    value: 'General Enquiry',
  },
  {
    name: 'Warranty Enquiry',
    value: 'Warranty Enquiry',
  },
  {
    name: 'Project Enquiry',
    value: 'Project Enquiry',
  }
];
export const State_Options = [
  {
    name: 'State',
    value: 'State',
  },
  {
    name: 'NSW',
    value: 'NSW',
  },
  {
    name: 'VIC',
    value: 'VIC',
  },
  {
    name: 'QLD',
    value: 'QLD',
  },
  {
    name: 'WA',
    value: 'WA',
  },
  {
    name: 'SA',
    value: 'SA',
  },
  {
    name: 'NT',
    value: 'NT',
  },
  {
    name: 'TAS',
    value: 'TAS',
  },
]
export const Preferred_Contact_Method_Options = [
  {
    name: 'Preferred Contact Method',
    value: 'Preferred Contact Method',
  },
  {
    name: 'Email',
    value: 'Email',
  },
  {
    name: 'Mail',
    value: 'Mail',
  },
  {
    name: 'Phone',
    value: 'Phone',
  },
  {
    name: 'Mobile',
    value: 'Mobile',
  },
];
export const Occupation_Options = [
  {
    name: 'Occupation',
    value: 'Occupation',
  },
  {
    name: 'Homeowner - Building Renovating',
    value: 'Homeowner - Building Renovating',
  },
  {
    name: 'Builder',
    value: 'Builder',
  },
  {
    name: 'Developer',
    value: 'Developer',
  },
  {
    name: 'Plumber',
    value: 'Plumber',
  },
  {
    name: 'Hydraulic Consultant',
    value: 'Hydraulic Consultant',
  },
  {
    name: 'Architect',
    value: 'Architect',
  },
  {
    name: 'Designer',
    value: 'Designer',
  },
  {
    name: 'Plumbing Merchant',
    value: 'Plumbing Merchant',
  },
];
export const Project_Type_Options = [
  {
    name: 'Project Type',
    value: 'Project Type'
  },
  {
    name: 'Aged Care',
    value: 'Aged Care',
  },
  {
    name: 'Hospital & Healthcare',
    value: 'Hospital & Healthcare',
  },
  {
    name: 'Multi-residential',
    value: 'Multi-residential',
  },
  {
    name: 'New build',
    value: 'New build',
  },
  {
    name: 'Offices',
    value: 'Offices',
  },
  {
    name: 'Education',
    value: 'Education',
  },
  {
    name: 'Retail & Hospitality',
    value: 'Retail & Hospitality',
  },
  {
    name: 'Entertainment',
    value: 'Entertainment',
  },
  {
    name: 'Transport',
    value: 'Transport',
  },
  {
    name: 'Government & Defense',
    value: 'Government & Defense',
  },
];
export const Source_Site = 'Specify';
